<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="7" v-for="e in entities" :key="e.id">
        <v-card shaped outlined>
          <v-card-title class="text-center">
            <span>{{ e.title }}</span>
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-btn :href="e.admin_route" large color="primary">
                <span v-t="'Go to admin'" />
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="10" md="8" lg="7">
        <v-card shaped outlined>
          <v-card-title class="text-center">
            <span v-t="'Add new business'" />
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-btn class="button add-entity" :to="{ name: 'add-entity' }" large color="primary">
                <span v-t="'Add new business'" />
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    entities() {
      return this.$store.state.entities;
    },
  },
};
</script>
